import {Injectable} from '@angular/core';
import {IMessage} from '@stomp/stompjs';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {WebsocketObservableMapper} from './websocket-observable.mapper';
import {IPostParcelList} from '../model/interface/post-parcel.model.interface';

@Injectable({
  providedIn: 'root'
})
export class PostParcelsObservableMapper implements WebsocketObservableMapper<IPostParcelList> {
  fromWebsocketMessage(message: Observable<IMessage>): Observable<IPostParcelList> {
    return message.pipe(
      map(messageInstance => JSON.parse(messageInstance.body) as IPostParcelList),
      filter(parcels => parcels !== null && parcels !== undefined)
    );
  }
}
